import { render, staticRenderFns } from "./ContractorInformationAdd.vue?vue&type=template&id=35c56c0c&"
import script from "./ContractorInformationAdd.vue?vue&type=script&lang=js&"
export * from "./ContractorInformationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports